import { useCallback, useEffect, useState } from 'react';
import type { AdvertsReply } from '@london-life/contracts';

// what the map needs to show the ads: who is on the boards, how fast they take turns, and the river plots held
export type MapAdverts = Pick<AdvertsReply, 'onAir' | 'plots'> & { rotateSeconds: number };
export const mapAdvertsOf = (reply: AdvertsReply | null): MapAdverts | null =>
  reply ? { onAir: reply.onAir, plots: reply.plots, rotateSeconds: reply.settings.rotateSeconds } : null;
import { api } from '../lib/api';
import { apiPictureFile } from '../lib/api-picture';

// what is on the map's boards: looked at when the map opens, every few minutes after, and again after a booking
const EVERY_MS = 5 * 60_000;

export function useAdverts() {
  const [reply, setReply] = useState<AdvertsReply | null>(null);
  const reload = useCallback(async () => {
    try {
      setReply(await api.adverts.list());
    } catch {
      // the boards keep what they show (or London's own adverts) until the next look
    }
  }, []);
  useEffect(() => {
    void reload();
    const timer = window.setInterval(() => void reload(), EVERY_MS);
    return () => window.clearInterval(timer);
  }, [reload]);
  return { reply, reload };
}

// a picture from the API (kept, so a board's turn never fetches it twice), and ready to draw on a board
export const advertFile = apiPictureFile;
export async function advertPicture(path: string): Promise<ImageBitmap | null> {
  const file = await advertFile(path);
  return file ? createImageBitmap(file).catch(() => null) : null;
}

// whose turn it is on a board: every board takes turns on the same clock for everyone, each a little apart
export function turnOf(count: number, board: number, rotateSeconds: number, now = Date.now()) {
  if (!count) return -1;
  return Math.floor(now / (rotateSeconds * 1000) + board * 0.37) % count;
}
